export default "__VITE_ASSET__ZhsqRogu__"